import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, getLanguageFolder, getSupportedLanguages } from './languageMapping';

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	// `getLanguageFolder` maps any accepted spelling (de, de-DE, de_de, el-GR, gr) to the folder on disk.
	.use(resourcesToBackend((language: string, namespace: string) => import(`../locales/${getLanguageFolder(language)}/${namespace}.json`)))
	.init({
		debug: false,
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: getSupportedLanguages(),
		cleanCode: true,
		ns: ['translation'],
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['querystring'],
		},
	});

export default i18n;
